import "./App.css";
import { Admin } from "./Pages/Admin/AdminFlight";
import { AdminHotel } from "./Pages/Admin/AdminHotel";
import { AllRoutes } from "./Pages/AllRoutes";
import { Booking } from "./Pages/booking/Booking";

function App() {
  return (
    <>
      <AllRoutes />
      {/* <Admin /> */}
      {/* <AdminHotel /> */}

      {/* <Booking/> */}
    </>
  );
}

export default App;
